import React, {Component} from 'react';
import {Icon, Form, Modal, Row, Col, Button} from 'antd';
import '../../css/wizard.css';
import {convertirAErrorApropiado, comparaArreglos, cambiaronProps} from '../../utils/funciones';
import { etiqueta_acudir_JDE } from '../../ApplicationResources';

class Wizard extends Component {
    constructor(props) {
        super(props);

        var pestaniasValidas = [];
        this.customValArr = [];
        for (var i = 0; i < this.props.lista.length; i++) {
            pestaniasValidas[i] = false;

            if (this.props.objetos[i] === undefined)
                this.props.objetos[i] = {};

            this.customValArr[i] = {};
        }

        this.state = {
            habilitarFlechaDer: false,
            activeIndex: props.activeIndex ? props.activeIndex : 0,
            pestaniasValidas: pestaniasValidas,
            modalAbrirConfirmacion : false,
            tipoUsuario: props.datosU !== undefined ? props.datosU.tipoUsuario:'',
            soloFUAR: props.soloFUAR !== undefined ? props.soloFUAR:''
        };

        props.form.customVal = this.customValArr[this.state.activeIndex];
        props.referencia.current = this;
    }

    componentDidMount() {
        this.form = this.props.form;
        this.props.form.setFields(this.props.objetos[this.state.activeIndex]); // si es modifica entonces setea los objetos props
        setTimeout(() => {
            this.props.form.validateFields();
        }, 0);

        this.formData = {};
        this.formData.formValues = this.props.form.getFieldsValue();
        this.formData.formErrors = this.props.form.getFieldsError();

        if (this.props.callbackPaso)
            this.props.callbackPaso(0, this.props.lista.length);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const newFormData = {}, oldFormData = this.formData;
        this.formData = newFormData;

        newFormData.formValues = nextProps.form.getFieldsValue();
        newFormData.formErrors = nextProps.form.getFieldsError();

        {
            const llaves1 = Object.keys(oldFormData.formValues);
            const llaves2 = Object.keys(newFormData.formValues);

            if (llaves1.length !== llaves2.length)
                return true;

            for (var i = 0; i < llaves1.length; i++) {
                if (!(llaves1[i] in newFormData.formValues) ||
                    oldFormData.formValues[llaves1[i]] !== newFormData.formValues[llaves1[i]])
                    return true;
            }
        }

        {
            const llaves1 = Object.keys(oldFormData.formErrors);
            const llaves2 = Object.keys(newFormData.formErrors);

            if (llaves1.length !== llaves2.length)
                return true;

            for (var i = 0; i < llaves1.length; i++) {
                if (!(llaves1[i] in newFormData.formErrors)) {
                    const errores1 = oldFormData.formErrors[llaves1[i]];
                    const errores2 = newFormData.formErrors[llaves1[i]];
                    if (!comparaArreglos(errores1, errores2))
                        return true;
                }
            }
        }

        return cambiaronProps(this.props, nextProps) || cambiaronProps(this.state, nextState);
    }

    cambiarEstado = (dir) => {
        if(this.state.activeIndex === 0 && !(this.props.modifica &&  this.state.tipoUsuario === 'E') && !this.state.soloFUAR){
            this.setState({modalAbrirConfirmacion:true});
        }else{
            this.setState(state => {
                const val = state.activeIndex + dir;

                this.props.form.customVal = this.customValArr[val];

                if (this.props.callbackPaso)
                    this.props.callbackPaso(val, this.props.lista.length);

                return {activeIndex: val}
            });
        }
    }

    aceptaInfo = (dir) =>{
        this.setState({modalAbrirConfirmacion:false});
        this.setState(state => {
            const val = state.activeIndex + dir;

            this.props.form.customVal = this.customValArr[val];

            if (this.props.callbackPaso)
                this.props.callbackPaso(val, this.props.lista.length);

            return {activeIndex: val}
            
        });
    }

    cancelaInfo = (dir) =>{
        this.setState({modalAbrirConfirmacion:false});
    }

    componentDidUpdate(_prevProps, prevState) {
        if (prevState.activeIndex !== this.state.activeIndex) {
            this.props.form.setFields(this.props.objetos[this.state.activeIndex]);
            setTimeout(this.props.form.validateFields, 0);
        }

        if (this.props.callValidacion !== undefined) {
            var valido = !this.state.pestaniasValidas.some(v => !v);
            this.props.callValidacion(valido, this.props.objetos, this.callbackResponse);
        }
    }

    cleanWizard = () => {
        const objetos = this.props.objetos;
        objetos.forEach((_, ind) => {objetos[ind] = {}});
        for (var i = 0; i < objetos.length; i++)
            this.customValArr[i] = {};
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        nextProps.form.customVal = this.props.form.customVal;
        const errors = nextProps.form.getFieldsError();
        const values = nextProps.form.getFieldsValue();
        var error = Object.values(errors).some(val => Boolean(val));
        const llaves = Object.keys(values);

        for (var i = 0; i < llaves.length; i++) {
            const llave = llaves[i];

            if (errors === null || errors[llave] === undefined) {
                const obj = {};
                this.props.objetos[this.state.activeIndex][llave] = obj;
                obj.value = values[llave];
            }
        }

        error = this.revisaNegocio(this.state.activeIndex, error);

        var pst = this.state.pestaniasValidas.slice();
        pst[this.state.activeIndex] = !error;

        this.setState({pestaniasValidas: pst,
                       habilitarFlechaDer: !error});

        if (error !== !this.state.habilitarFlechaDer)
            this.establecerEstadoError(error);

    }

    callbackResponse = (errors) => {
        if (!errors) {
            this.cleanWizard();
            return;
        }

        var min = undefined;
        Object.keys(errors).map(key => {
            key = parseInt(key);
            const pestaniaValores = errors[key];
            var tieneValoresOErrores = false;

            Object.keys(pestaniaValores).map(llave => {
                const valor = pestaniaValores[llave];
                var eliminarObjeto = true;
                if (valor.values !== undefined || valor.error !== undefined) {
                    tieneValoresOErrores = true;
                    eliminarObjeto = false;
                }

                if (valor.validacion !== undefined)
                    this.customValArr[key][llave] = valor.validacion;

                if (eliminarObjeto)
                    delete pestaniaValores[llave];
            });

            if(!tieneValoresOErrores)
                return;

            min = min === undefined ? key : Math.min(min, key);

            const convertidos = convertirAErrorApropiado(pestaniaValores, this.props.objetos[key]);
            Object.assign(this.props.objetos[key], convertidos);
        });

        if (min === this.state.activeIndex)
            this.props.form.setFields(this.props.objetos[min]);

        this.establecerEstadoError(min !== undefined, min);
        this.props.callValidacion(false, this.props.objetos, this.callbackResponse);
    }

    establecerEstadoError(error, pestaniaActiva) {
        this.setState(state => {
            pestaniaActiva = pestaniaActiva !== undefined ? pestaniaActiva : state.activeIndex;

            error = this.revisaNegocio(pestaniaActiva, error);

            var pst = state.pestaniasValidas.slice();
            pst[pestaniaActiva] = !error;

            this.props.form.customVal = this.customValArr[pestaniaActiva];

            if (this.props.callbackPaso)
                this.props.callbackPaso(pestaniaActiva, this.props.lista.length);

            return {habilitarFlechaDer: !error,
                    pestaniasValidas: pst,
                    activeIndex: pestaniaActiva}
        });
    }

    revisaNegocio (pestaniaActiva, error) {
        const customVal = this.customValArr[pestaniaActiva];

        Object.values(customVal).map(val => {
            if (!val)
                error = true;
        });

        return error;
    }

    cambiaNegocio(nombreCampo, valido) {
        if(nombreCampo in this.props.form.customVal)
            this.props.form.customVal[nombreCampo] = valido;

        this.props.form.validateFields();
    }

    render() {
        const flechaIzquierda = this.state.activeIndex === 0 ? undefined :
                                (<span className="flecha_wizard flecha_wizard_active flecha_wizard_left" onClick={() => this.cambiarEstado(-1)}>
                                    <Icon component={FlechaIzq}/>
                                    <span>&nbsp;Anterior</span>
                                </span>);

        const cambio = this.state.habilitarFlechaDer ? () => this.cambiarEstado(1) : undefined;
        const clase = this.state.habilitarFlechaDer ? 'flecha_wizard_active' : '';
        const flechaDerecha = this.state.activeIndex === this.props.lista.length - 1 ?
                              (<span className={"flecha_wizard flecha_wizard_right"}>{this.props.botonFinal}</span>) :
                              (<span className={"flecha_wizard " + clase + " flecha_wizard_right"} onClick={cambio}>
                                <span>Siguiente&nbsp;</span>
                                <Icon component={FlechaDer}/>
                              </span>);

        return (
            <div>
                <div className="contenido_wizard">
                    {React.cloneElement(this.props.lista[this.state.activeIndex],  {form: this.props.form})}
                </div>
                <div>
                    {flechaDerecha}
                    {flechaIzquierda}
                </div>
                <div style={{clear: 'both'}}></div>
                <Modal title={null}
                       centered
                       visible={this.state.modalAbrirConfirmacion}
                       onOk={null}
                       onCancel={null}
                       closable={false}
                       footer={null}>
                    <Row>
                        
                            <h3 className="titulosAvisoPrivacidad" style={{ 'textAlign': 'center' }}> ¿Son correctos los datos ingresados? </h3> 
                        
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <span style={{'font-weight':'700', 'fontSize': '16px'}}>Estado:</span>
                            <br/>
                            <span >{this.state.modalAbrirConfirmacion ? this.props.objetos[0].listaEstados[this.props.objetos[0].idEstado.value].nombreEstado:''}</span>
                        </Col>
                        <Col lg={12}>
                            <span style={{'font-weight':'700', 'fontSize': '16px'}}>Proceso Electoral:</span>
                            <br/>
                            <span >{this.state.modalAbrirConfirmacion ? this.props.objetos[0].listaProcesos.find(item => item.idDetalleProceso === this.props.objetos[0].idDetalleProceso.value).descripcionDetalleLarga :''}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <h3 className="titulosAvisoPrivacidad" > Datos del aspirante: </h3>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <span style={{'font-weight':'700', 'fontSize': '16px'}}>Distrito:</span>
                            <br/>
                            <span >{this.state.modalAbrirConfirmacion ? (this.props.datosU !== undefined ? this.props.objetos[0]['nombreDttoCredencial'] ? this.props.objetos[0]['nombreDttoCredencial'].value : '': this.props.objetos[0].nombreDistrito) : ''}
                            </span>
                        </Col>
                        <Col lg={12}>
                            <span style={{'font-weight':'700', 'fontSize': '16px'}}>Sección electoral:</span>
                            <br></br>
                            <span >{this.state.modalAbrirConfirmacion ? this.props.objetos[0].seccion.value:''}</span>
                        </Col>
                    </Row>
                    <div style={{'display':this.props.datosU !== undefined ? 'block':'none'}}>
                    <Row >
                        <h3 className="titulosAvisoPrivacidad" > Datos del distrito donde participará la/el aspirante: </h3>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <span style={{'font-weight':'700', 'fontSize': '16px'}}>Distrito:</span>
                            <br/>
                            <span >{this.state.modalAbrirConfirmacion && this.props.objetos[0]['participaOtroDttoRadio'].value === 'S' ? (this.props.objetos[0]['distritoNuevo'].value ? this.props.objetos[0]['distritoNuevo'].value : '') 
                            : this.state.modalAbrirConfirmacion  ? (this.props.objetos[0].nombreDistrito ? this.props.objetos[0].nombreDistrito : ''): ''}
                            </span>
                        </Col>
                        <Col lg={12}>
                            <span style={{'font-weight':'700', 'fontSize': '16px'}}>Sección electoral:</span>
                            <br/>
                            <span >{this.state.modalAbrirConfirmacion && this.props.objetos[0]['participaOtroDttoRadio'].value === 'S' ? this.props.objetos[0].idSeccionDOM.value
                            : this.state.modalAbrirConfirmacion ? this.props.objetos[0].seccion.value : '' }</span>
                        </Col>
                    </Row>
                    </div>
                    <div>
                        <span style={{'font-weight':'700', 'fontSize': '16px'}}>Clave de elector, OCR o SIAP:</span>
                    </div>
                    <div>
                        <span >{this.state.modalAbrirConfirmacion ? this.props.objetos[0].claveElectorFuar.value:''}</span>
                    </div>
                    <br/><br/>
                    <div id="modal_botones">
                        
                        <Button className="botonesModal" style={{width: 150}} onClick={() => this.cancelaInfo(1)}> Cancelar </Button>
                        <Button className="botonesModal" style={{width: 150}} onClick={() => this.aceptaInfo(1)}> Aceptar </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

function FlechaDer() {
    return (
        <svg width='1em' height='1em' fill='currentColor' className='ruta'
             viewBox='0 0 28 28'>
            <path d="M 0 14 A 14 14 0 1 1 28 14 A 14 14 0 1 1 0 14 " />
            <path d="M 6 12 L 18 12 L 14 8 L 16 6 L 24 14 L 16 22 L 14 20 L 18 16 L 6 16 A 1 1 0 1 1 6 12" fill="white"/>
        </svg>
    );
}

function FlechaIzq() {
    return (
        <svg width='1em' height='1em' fill='currentColor' className='ruta'
             viewBox='0 0 28 28'>
            <path d="M 0 14 A 14 14 0 1 1 28 14 A 14 14 0 1 1 0 14 " />
            <path d="M 22 12 L 10 12 L 14 8 L 12 6 L 4 14 L 12 22 L 14 20 L 10 16 L 22 16 A 1 1 0 1 0 22 12" fill="white"/>
        </svg>
    );
}

export default Form.create({ name: 'wizard' })(Wizard);
